import * as faqs from "./faqs";
import * as notifications from "./notifications";
import * as questions from "./questions";

export const center = {
    ...faqs,
    ...notifications,
    ...questions,
}
